import api from './api';

const BRANCH_CACHE_PREFIX = 'branches:';

const branchService = {
  getAll: async () => {
    const response = await api.cachedGet('/branches', {}, {
      cacheKey: `${BRANCH_CACHE_PREFIX}all`,
      ttlMs: 5 * 60 * 1000
    });
    return response.data;
  },

  create: async (branchData) => {
    const response = await api.post('/branches', branchData);
    api.invalidateCache(BRANCH_CACHE_PREFIX, 'reports:dashboard');
    return response.data;
  },
  update: async (id, branchData) => {
    const response = await api.put(`/branches/${id}`, branchData);
    api.invalidateCache(BRANCH_CACHE_PREFIX, 'reports:dashboard');
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/branches/${id}`);
    api.invalidateCache(BRANCH_CACHE_PREFIX, 'reports:dashboard', 'tickets:list:');
    return response.data;
  },
};

export default branchService;
